var escape = require("../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fmcy-favourite-button {\n  cursor: pointer; }\n  .fmcy-favourite-button .farm-favourite-button-inner {\n    background-image: url(" + escape(require("./img/heart_outlined.png")) + ");\n    width: 120px;\n    height: 106px;\n    background-size: cover; }\n  .fmcy-favourite-button.farm-favourited .farm-favourite-button-inner {\n    background-image: url(" + escape(require("./img/heart_filled.png")) + "); }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/js/common/menu/common/favourite-button/favourite-button.scss
 ** module id = 135
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 16 17 22 25 26 140
 **/